import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../../providers/TacticHooksProvider';

export const useGetAmenities = () => {
  const { apiClient } = useTacticHooks();

  return useQuery({
    queryKey: ['tags', 'amenities'],

    queryFn: async () => {
      const res = await apiClient.tags.getTags({
        type: 'amenity'
      });
      return res;
    },

    enabled: !!apiClient.slug
  });
};
